import { useEffect } from 'react'
import useZendesk from './use-zendesk'

const useZendeskWidget = () => {
  const showZendesk = useZendesk()

  useEffect(() => {
    const scriptUrl =
      'https://static.zdassets.com/ekr/snippet.js?key=6218ca5e-7039-418a-855c-35879c0c5cff'

    // check if script already exists
    const existingScript = document.querySelector(`script[src='${scriptUrl}']`)

    if (existingScript === null && showZendesk) {
      const script = document.createElement('script')
      script.id = 'ze-snippet'
      script.src = scriptUrl
      script.async = true
      document.head.appendChild(script)

      // push zendesk widget below lightbox overlay (create listing > photo)
      // zendesk's window.zESettings does not work for some reason
      const intervalId = setInterval(() => {
        const zendeskIframe = document.getElementById('launcher') // iframe host container for zendesk
        if (zendeskIframe) {
          zendeskIframe.style.zIndex = 99 // default is 999999
          clearInterval(intervalId)
        }
      }, 100)
    }
  }, [showZendesk])
}

export default useZendeskWidget
